import { Star } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const testTraumeIzDetinjstva: QuizConfig = {
  id: "traume-iz-detinjstva",
  illustration: {
    src: "/images/quizzes/traume-iz-detinjstva.webp",
    alt: "Žena u svom domu pažljivo posmatra fotografiju iz detinjstva.",
  },
  lastModified: "2026-10-05",
  title: "Koja je tvoja trauma iz detinjstva?",
  shortTitle: "Test traume iz detinjstva",
  description:
    "Istraži događaje iz detinjstva koji su oblikovali tvoje sadašnje reakcije i ponašanja.",
  icon: Star,
  duration: "4-6 min",
  category: "Mentalno zdravlje",
  relatedDirectorySlugs: ["trauma-iz-detinjstva", "trauma"],
  focusAreasWanted: [
    "trauma",
    "self_development",
    "relationships",
    "family_issues",
  ],
  questions: [
    {
      type: "radio",
      question: "Kada pomisliš na svoje detinjstvo, šta prvo osećaš?",
      options: [
        "Sreću i toplinu",
        "Blagu nostalgiju",
        "Pomešana osećanja",
        "Tugu ili bol",
        "Bes i frustraciju",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "radio",
      question:
        "Koliko često razmišljaš o negativnim iskustvima iz detinjstva?",
      options: ["Nikada", "Retko", "Ponekad", "Često", "Stalno"],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje situacije iz detinjstva su ti najviše ostale u sećanju? (označi sve što važi)",
      options: [
        "Svađe u porodici",
        "Osećaj zanemarenosti",
        "Težak odnos sa vršnjacima",
        "Gubitak bliske osobe",
        "Veliki pritisak da budeš savršen/a",
        "Srećni i radosni trenuci",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Kako bi opisao/la svoj odnos sa roditeljima u detinjstvu?",
      options: [
        "Veoma blizak i podržavajući",
        "Uglavnom dobar",
        "Ponekad komplikovan",
        "Često težak",
        "Distanciran i hladan",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "textarea",
      question: "Koji događaj iz detinjstva ti je ostavio najjači utisak?",
    },
    {
      type: "radio",
      question: "Kako ti detinjstvo utiče na tvoje sadašnje odnose?",
      options: [
        "Pozitivno, daje mi snagu",
        "Neutralno, nema velikog uticaja",
        "Ponekad izaziva poteškoće",
        "Često komplikuje moje odnose",
        "Uglavnom stvara prepreke",
      ],
      scores: [0, 1, 2, 3, 4],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koji od ovih osećaja često povezuješ sa detinjstvom? (označi sve što važi)",
      options: [
        "Sigurnost i ljubav",
        "Strah i nesigurnost",
        "Ponos i postignuće",
        "Tuga i gubitak",
        "Bes i frustraciju",
        "Neutralnost",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "radio",
      question: "Da li osećaš da te detinjstvo još uvek definiše?",
      options: ["Nimalo", "Malo", "Donekle", "Dosta", "Potpuno"],
      scores: [0, 1, 2, 3, 4],
    },
  ],
  copy: {
    title: "Kako te detinjstvo oblikovalo?",
    subtitle: "Analiza tvojih detinjih iskustava",
    scoreLabel: "Rezultat:",
    adviceTitle: "Kako da razumeš i prevaziđeš svoju prošlost",
    resourcesTitle: "Korisni resursi",
    whatNextTitle: "Šta dalje",
    shareButtonText: "Podeli rezultat",
  },
};
